module.exports = __webpack_public_path__ + "img/gzh.697d0ff7.jpg";